import { useState, useEffect } from 'react';

const usePWAInstall = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Listen for the install prompt event
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      // Only show button after user has used the app for a while
      const timer = setTimeout(() => {
        const hasDeclined = localStorage.getItem('pwa_install_declined');
        if (!hasDeclined) {
          setShowInstallButton(true);
        }
      }, 45000); // 45 seconds - good balance

      return () => clearTimeout(timer);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // App installed successfully
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setShowInstallButton(false);
      localStorage.setItem('pwa_installed', 'true');
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const installPWA = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setShowInstallButton(false);
      localStorage.setItem('pwa_installed', 'true');
    } else {
      // User dismissed the prompt
      localStorage.setItem('pwa_install_declined', 'true');
    }

    setDeferredPrompt(null);
  };

  const dismissInstallButton = () => {
    setShowInstallButton(false);
    localStorage.setItem('pwa_install_declined', 'true');
  };

  return { 
    showInstallButton, 
    installPWA, 
    dismissInstallButton,
    isInstalled 
  };
};

export default usePWAInstall;